import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "k-keypad" }
const _hoisted_2 = { class: "k-keypad__wrapper" }
const _hoisted_3 = ["onClick"]

import { reactive, watchEffect } from 'vue'

interface IKey {
  model?: string
  icon?: string
  text?: string
  caption?: string
}

interface IProps {
  modelValue: IKey
  keys: IKey[]
  disable?: boolean
  columns?: number
  clickType?: 'select' | 'click'
  keyBgColor?: string
}

interface IEmits {
  (event: 'update:modelValue', data: IKey): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KKeypad' },
  __name: 'KKeypad',
  props: {
    modelValue: {},
    keys: {},
    disable: { type: Boolean, default: false },
    columns: { default: 3 },
    clickType: { default: 'select' },
    keyBgColor: { default: 'var(--off-white-20)' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v18f18a04": (props.columns),
  "v0e628f8c": (_ctx.keyBgColor)
}))



const props = __props
const emit = __emit

const state = reactive({
  ...props,
})

const handleButtonClick = (key: IKey) => {
  if (props.clickType === 'select') {
    if (state.modelValue.model === key.model) state.modelValue = {}
    else state.modelValue = key
    emit('update:modelValue', state.modelValue)
  } else {
    emit('update:modelValue', key)
  }
}

watchEffect(() => {
  state.keys = props.keys
  state.clickType = props.clickType
  if (state.clickType === 'select') state.modelValue = props.modelValue
  else state.modelValue = {}
})

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.keys, (key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["k-keypad__button rounded-20 flex column items-center justify-center transition cursor-pointer q-pa-sm non-selectable", [
          {
            'k-keypad__button--active': state.modelValue && key.model === state.modelValue.model && !__props.disable,
          },
          { 'k-keypad__button--disable': __props.disable },
        ]]),
          onClick: ($event: any) => (handleButtonClick(key))
        }, [
          (key.icon)
            ? (_openBlock(), _createBlock(_component_k_icon, {
                key: 0,
                class: "k-keypad__icon",
                color: !key.text && !key.caption && !__props.disable ? 'cool-gray-100' : 'cool-gray-70',
                size: "24px",
                name: key.icon
              }, null, 8 /* PROPS */, ["color", "name"]))
            : _createCommentVNode("v-if", true),
          (key.text)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["k-keypad__value fs-28px text-center transition", __props.disable ? 'text-cool-gray-70' : 'text-cool-gray-100'])
              }, _toDisplayString(key.text), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true),
          (key.caption)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass(["k-keypad__caption text-center transition fs-13px fw-500", [!key.text && !__props.disable ? 'text-cool-gray-100' : 'text-cool-gray-70 has-text']])
              }, _toDisplayString(key.caption), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true),
          _renderSlot(_ctx.$slots, key.model)
        ], 10 /* CLASS, PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})